/** Current state of the data updater. */
export enum DataUpdateState { 
	/**
	* No update is available.
	*             The data on the Device is up to date.
	*/
	UpToDate = "UpToDate", 
	/**
	* A newer version of the Device config was received
	*             from the Backend and is now being checked.
	*/
	CheckDeviceUpdate = "CheckDeviceUpdate", 
	/**
	* The new config contains images which are not yet known
	*             on the local side. They are currently downloaded.
	*/
	DownloadImages = "DownloadImages", 
	/**
	* The new config and all required images were downloaded.
	*             The data update can be started now.
	*/
	ReadyForUpdate = "ReadyForUpdate", 
	/** The data update is currently being applied. */
	Updating = "Updating"
}
